export default __webpack_public_path__ + "static/media/case_emergency.bfd5be4c.pdf";